import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0Icon } from '@factorialco/f0-react'
import { Widget } from '@factorialco/f0-react/dist/experimental'
import { InfoCircleLine } from '@factorialco/f0-react/icons/app'

import PopoverMenu from 'modules/core/components/PopoverMenu'
import { i18nDateToString, stringToDate } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

const BreakdownRow = ({ label, value }: { label: string; value: number }) => (
  <Box flexDirection="row" justifyContent="spaceBetween">
    <Text.Normal size="200">{label}</Text.Normal>
    <Text.Normal size="200">{i18n.t('clock_in.worked_days', { days: value })}</Text.Normal>
  </Box>
)

const CounterWidget = ({
  loading,
  total,
  remainingWorkDays,
  totalPaidAbsences,
  totalWorkedDays,
  cycleStartDate,
  cycleEndDate,
  year,
}: {
  loading: boolean
  total: number
  remainingWorkDays: number
  totalPaidAbsences: number
  totalWorkedDays: number
  cycleStartDate: string | null
  cycleEndDate: string | null
  year: number
}) => {
  const startDate = cycleStartDate ? stringToDate(cycleStartDate, 'backend') : new Date(year, 0, 1)
  const endDate = cycleEndDate ? stringToDate(cycleEndDate, 'backend') : new Date(year, 11, 31)

  if (loading) {
    return (
      <Box maxWidth="s600">
        <Widget.Skeleton />
      </Box>
    )
  }

  return (
    <Box maxWidth="s600">
      <Widget
        header={{
          title: i18n.t('clock_in.remaining_work_days'),
          subtitle: i18n.t('clock_in.daily_cycle', {
            start: i18nDateToString(startDate, 'ui_month_year'),
            end: i18nDateToString(endDate, 'ui_month_year'),
          }),
          info: i18n.t('clock_in.remaining_work_days_description'),
        }}
      >
        <PopoverMenu type="list">
          <Box flexDirection="row" gap="s4" alignItems="center">
            <Text weight="semibold" size="400" color="grey1000">
              {i18n.t('clock_in.worked_days', {
                days: remainingWorkDays,
              })}
            </Text>
            <PopoverMenu.Trigger>
              <Box alignItems="center">
                <F0Icon icon={InfoCircleLine} size="sm" color="secondary" />
              </Box>
            </PopoverMenu.Trigger>
          </Box>
          <PopoverMenu.Content side="bottom" align="center" width="s300">
            <Box paddingY="s8" paddingX="s16" gap="s8">
              <Text size="200" weight="semibold" color="grey1000">
                {i18n.t('clock_in.balance_breakdown.title')}
              </Text>
              <BreakdownRow label={i18n.t('clock_in.annual_days')} value={total} />
              <BreakdownRow label={i18n.t('clock_in.daily_worked_days')} value={totalWorkedDays} />
              <BreakdownRow label={i18n.t('clock_in.paid_absences')} value={totalPaidAbsences} />
            </Box>
          </PopoverMenu.Content>
        </PopoverMenu>
      </Widget>
    </Box>
  )
}

export default CounterWidget
